import { Group, Button, NumberInput, Select, Box, LoadingOverlay } from '@mantine/core';

import { useCreateShopCommission } from '../hooks/use-create-shop-commission';

type Props = {
  onClose: () => void;
};

export const CreateShopCommissionForm = (props: Props) => {
  const {
    onClose,
  } = props;

  const {
    form,
    selectedShopId,
    shops,
    paymentMethods,
    isLoading,
    onSubmit,
  } = useCreateShopCommission();

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values, onClose))}>
      <Box pos="relative">
        <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
        <Select
          label="ID магазина"
          placeholder=""
          data={shops?.map((shop) => ({ value: shop.id.toString(), label: `${shop.id} - ${shop.name}` }))}
          key={form.key('shopId')}
          {...form.getInputProps('shopId')}
        />
        <Select
          label="ID платёжного метода"
          placeholder=""
          disabled={!selectedShopId}
          data={paymentMethods?.map((method) => ({ value: method.id.toString(), label: `${method.id} - ${method.key} (${method.name})` }))}
          key={form.key('paymentMethodId')}
          {...form.getInputProps('paymentMethodId')}
        />
      </Box>
      <NumberInput
        label="Процент пополнения"
        placeholder=""
        decimalScale={10}
        step={0.1}
        min={0}
        max={100}
        key={form.key('refillPercent')}
        {...form.getInputProps('refillPercent')}
      />
      <NumberInput
        label="Комиссия с клиента (%)"
        placeholder=""
        decimalScale={10}
        step={0.1}
        min={0}
        max={100}
        key={form.key('additionalPercent')}
        {...form.getInputProps('additionalPercent')}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Добавить
        </Button>
      </Group>
    </form>
  );
};
